<template>
  <b-card
    border-variant="secondary"
    header-bg-variant="light"
    header-class="p-3 font-weight-bold"
    header="Record relationships"
    class="mb-0"
  >
    <div class="d-flex flex-wrap align-items-center mb-3">
      <div
        v-for="(node, idx) in nodes"
        :key="node.key"
        class="d-flex align-items-center"
      >
        <div class="border rounded px-3 py-2 mr-2 mb-2 bg-white">
          <div class="small text-muted text-uppercase">{{ node.role }}</div>
          <div class="font-weight-bold text-dark">{{ node.label }}</div>
          <div v-if="node.detail" class="small text-muted">{{ node.detail }}</div>
        </div>
        <span v-if="idx < nodes.length - 1" class="text-muted mr-2 mb-2">→</span>
      </div>
    </div>

    <div v-if="sourceLinks.length" class="small">
      <div class="font-weight-bold text-dark mb-1">Source links</div>
      <ul class="pl-3 mb-0">
        <li v-for="(link, idx) in sourceLinks" :key="idx">
          <a
            v-if="link.href"
            :href="link.href"
            target="_blank"
            rel="noopener noreferrer"
          >{{ link.label }}</a>
          <span v-else>{{ link.label }}</span>
          <span v-if="link.detail" class="text-muted"> — {{ link.detail }}</span>
        </li>
      </ul>
    </div>
    <div v-else class="small text-muted">
      Controlled source links appear when the server builds safe destinations for this row.
    </div>
  </b-card>
</template>

<script>
export default {
  name: "RelationshipStrip",

  props: {
    review: {
      type: Object,
      default: null
    },
    sourceLinks: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },

  computed: {
    nodes: function () {
      const r = this.review || {};
      const policy = r.policy || {};
      const debtor = r.debtor || {};
      const carrier = policy.insurer || r.carrierName || "Carrier";
      return [
        {
          key: "client",
          role: "Client",
          label: policy.client || "—",
          detail: policy.clientId ? `Zoho ${policy.clientId}` : null
        },
        {
          key: "policy",
          role: "Policy",
          label: policy.number || "—",
          detail: policy.id ? `Zoho ${policy.id}` : null
        },
        {
          key: "broker",
          role: "Producing broker / debtor",
          label: debtor.label || debtor.name || "Producing broker",
          detail: debtor.authorisedRepId != null
            ? `INSIGHT AR ${debtor.authorisedRepId}`
            : null
        },
        {
          key: "carrier",
          role: "Carrier",
          label: carrier,
          detail: "From product relationship at effective date"
        },
        {
          key: "product",
          role: "Product",
          label: r.productCode || "—",
          detail: r.productCode ? "Canonical product code" : "Product code not proved"
        }
      ];
    }
  }
};
</script>
